document.addEventListener("DOMContentLoaded", function () {
  var acc = document.querySelectorAll(".accordionmbmenu, .accordion-new");

  acc.forEach(function (element) {
    element.addEventListener("click", function () {
      // This closes all other panels at the same level, but keeps parent panels open if nested.
      let isNested = element.classList.contains("accordion-new");
      let currentPanel = element.nextElementSibling;

      if (isNested) {
        // Close only sibling nested accordions, keep parent open
        let parentPanel = element.closest(".panel");
        parentPanel
          .querySelectorAll(".accordion-new")
          .forEach(function (nestedElement) {
            if (nestedElement !== element) {
              nestedElement.classList.remove("active");
              nestedElement.nextElementSibling.style.display = "none";
            }
          });
      } else {
        // Close all first-level accordions
        document
          .querySelectorAll(".accordionmbmenu")
          .forEach(function (mainElement) {
            if (mainElement !== element) {
              mainElement.classList.remove("active");
              mainElement.nextElementSibling.style.display = "none";
            }
          });
      }

      // Toggle current accordionmbmenu
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  });
});
